<template>
  <div id="app" class="wrapper" data-app>
    <header class="header">
      <svg class="logo" viewBox="0 0 667.73334 138.66667">
        <path
          style="fill:#cce533;fill-opacity:1;stroke-width:0.35355338"
          d="m 176.34082,100.48117 c 0,-22.51336 0.13083,-38.03342 0.3206,-38.03342 0.17633,0 1.35417,0.46374 2.61743,1.03052 4.68758,2.10318 17.57035,6.75805 23.04815,8.32788 17.31986,4.96354 31.37989,5.42809 43.50696,1.43748 8.1475,-2.68107 11.63568,-4.93902 19.11377,-12.37266 6.84078,-6.80012 9.82205,-11.14893 13.5827,-19.81319 4.36206,-10.0499 7.08031,-19.26529 9.69871,-32.88047 l 1.49585,-7.77818 12.42761,-0.0929 12.4276,-0.0929 -0.0244,28.02363 c -0.0261,30.01501 -0.239,38.02314 -1.03625,38.98377 -0.6087,0.73344 -1.48754,0.59047 -7.60141,-1.23657 -2.5279,-0.75543 -5.55079,-1.56116 -6.71751,-1.79052 -3.10253,-0.6099 -17.45612,-0.85633 -20.68629,-0.35515 -10.71714,1.66282 -25.40009,13.16518 -34.10439,26.71677 -5.73607,8.9304 -14.48429,27.00891 -19.76033,40.83542 -0.70491,1.84732 -1.60436,3.8854 -1.99877,4.52908 -1.4653,2.39135 -0.98141,2.34311 -24.83166,2.47556 l -21.47837,0.11929 z"
          id="path100"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#cce533;fill-opacity:1;stroke-width:0.08838835"
          d="m 202.03215,57.97933 c -4.71013,-0.10172 -8.054,-0.41661 -12.9489,-1.2194 -5.73734,-0.94095 -8.40266,-1.62357 -10.70297,-2.74114 -1.16394,-0.56548 -1.48663,-0.87712 -1.56812,-1.51444 -0.17699,-1.38415 -0.33366,-4.62356 -0.51032,-10.55196 -0.0514,-1.72579 -0.11459,-11.83852 -0.14036,-22.47274 l -0.0469,-19.33495 33.61954,0.001 c 32.44339,0.001 48.06382,0.0707 59.25216,0.26418 5.38773,0.0932 9.41275,0.22084 10.10518,0.32051 0.35961,0.0518 0.37907,0.0689 0.32568,0.28707 -0.15997,0.65375 -3.46843,7.00718 -5.50483,10.57125 -3.24117,5.67265 -7.77866,12.83642 -9.96666,15.73533 -2.41021,3.19331 -5.58847,6.90726 -8.85771,10.35069 -4.48429,4.72321 -10.00038,9.1886 -15.22562,12.32546 -3.3482,2.01001 -8.51881,4.23983 -13.17695,5.68255 -2.31826,0.71801 -4.65741,1.12934 -9.09691,1.59966 -5.79426,0.61384 -10.21993,0.81209 -15.55635,0.69685 z m 13.38558,-14.17496 c 3.00162,-0.20416 5.84202,-0.73805 7.2579,-1.36422 1.44006,-0.63687 4.20145,-2.85733 5.76361,-4.6346 1.75337,-1.9948 3.69596,-5.71882 4.31412,-8.27034 0.41847,-1.72728 0.51691,-2.73866 0.52061,-5.34888 0.003,-2.02092 -0.0236,-2.55733 -0.15673,-3.18198 -0.93897,-4.40373 -4.13511,-8.77592 -9.10736,-12.45851 -2.061,-1.52642 -3.45507,-2.13384 -6.18346,-2.6942 -3.07853,-0.63227 -5.17102,-0.51413 -8.45567,0.47743 -2.33116,0.70371 -3.7296,1.35388 -5.61503,2.61054 -3.41857,2.27853 -5.12749,4.13561 -6.88718,7.48429 -1.62831,3.09867 -2.04657,4.97071 -1.97129,8.82309 0.0473,2.42166 0.18019,3.39473 0.72053,5.27666 0.61601,2.1455 1.75197,4.65914 2.63297,5.82619 0.94018,1.24544 3.08232,3.29159 4.78741,4.57289 2.5418,1.91003 4.68897,2.66928 8.14048,2.87851 1.69583,0.10281 2.7621,0.10359 4.23909,0.003 z"
          id="path102"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#ffcc15;fill-opacity:1;stroke-width:0.5"
          d="M 0.4460823,100.98488 V 63.51552 l 2.125,-0.29184 C 3.7398323,63.06316 9.646082,62.37497 15.696082,61.69436 40.568457,58.89627 43.450524,58.44083 43.440959,57.30998 43.435059,56.6082 33.124162,27.46566 32.749105,27.0906 32.243781,26.58528 29.321401,29.48839 7.566374,52.10728 L 0.4460823,59.5103 V 29.98228 0.45425 h 22.4999997 22.5 l 0.0026,1.125 c 0.0097,4.23115 1.148492,21.18925 1.761842,26.23546 1.919011,15.78825 8.985673,28.34771 20.985588,37.29735 6.52507,4.86644 14.97302,8.45984 23,9.7832 11.750848,1.9373 27.197328,0.64601 40.994738,-3.42706 3.36269,-0.99268 5.15984,-1.30948 5.5,-0.96953 0.32738,0.32717 0.55734,12.3781 0.65319,34.23025 l 0.14794,33.72533 H 69.469007 0.4460823 Z M 108.15137,127.328 c 4.43745,-10.49343 14.15037,-38.68476 13.53894,-39.29619 -0.91545,-0.91545 -31.141633,-1.34951 -32.029288,-0.45996 -0.20175,0.20219 0.34355,2.45219 1.211785,5 2.455935,7.2069 14.757493,39.38255 15.056393,39.38115 0.14679,-5e-4 1.14676,-2.08194 2.22217,-4.625 z M 54.152012,98.0034 c 12.662405,-6.5962 21.772725,-11.86444 21.78788,-12.5993 0.015,-0.72658 -18.862685,-13.61304 -23.349445,-15.93904 -3.174496,-1.64571 -3.786249,-1.3054 -4.486049,2.4955 -0.745299,4.04803 -2.991172,21.42361 -3.440586,26.61869 -0.25855,2.98875 -0.188919,3.875 0.304455,3.875 0.35182,0 4.484505,-2.00288 9.183745,-4.45085 z"
          id="path104"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#0f4274;fill-opacity:1;stroke-width:0.5"
          d="m 362.64438,138.08016 -9.55171,-0.14699 -0.3203,-4.11446 c -0.17616,-2.26296 -0.32164,-20.7127 -0.32329,-40.99944 l -0.003,-36.88497 9.06572,-6.75173 c 11.20051,-8.34163 15.8702,-11.43099 23.86216,-15.78664 11.50021,-6.26766 23.38337,-10.45814 33.74252,-11.89897 7.12695,-0.99127 18.34263,-0.68907 24.8296,0.66901 9.74433,2.04003 19.08907,5.94221 27.09907,11.31605 5.93705,3.98311 18.45152,13.58703 18.28093,14.02923 -0.24587,0.63735 -15.63603,15.07107 -20.9914,19.68686 -13.42256,11.5689 -29.38962,19.7198 -44.17742,22.55176 -9.41196,1.80246 -21.72142,1.90418 -29.71118,0.24552 -6.38146,-1.32478 -14.65797,-3.73199 -23.25106,-6.76253 -3.53509,-1.24673 -6.53026,-2.16396 -6.65592,-2.0383 -0.45096,0.45096 1.62561,3.07003 5.11015,6.44514 11.75292,11.38383 26.67897,19.75738 40.79683,22.8871 6.91035,1.53192 19.0149,1.65913 25.4714,0.2677 10.37547,-2.23602 25.06115,-8.55136 34.29801,-14.74932 4.19763,-2.81661 12.62109,-9.36934 18.60559,-14.47354 l 2.625,-2.23887 v 29.56074 29.56074 l -59.625,-0.11355 c -32.79375,-0.0625 -63.92327,-0.17969 -69.1767,-0.26054 z m 69.57178,-65.22742 c 2.87752,-1.49467 6.17631,-4.85317 7.69951,-7.83887 1.63767,-3.21011 2.32279,-8.83218 1.62404,-13.32675 -1.19582,-7.69182 -4.91525,-11.87395 -12.73653,-14.32099 -4.86086,-1.52082 -9.62027,-1.35094 -13.53989,0.48327 -5.48688,2.56762 -8.73888,6.40823 -10.79261,12.74603 -1.42223,4.38899 -0.30116,11.61624 2.50657,16.15925 1.47022,2.37887 4.93277,5.08617 8.33314,6.51551 2.59481,1.09073 3.46529,1.1968 8.63569,1.05227 5.04539,-0.14103 6.05881,-0.32113 8.27008,-1.46972 z"
          id="path106"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#0f4274;fill-opacity:1;stroke-width:0.5"
          d="M 353.44608,17.52951 V 0.45425 l 22.625,0.0161 22.625,0.0161 -8.5,4.36743 c -4.675,2.40208 -9.85,5.23611 -11.5,6.29783 -4.7406,3.05042 -10.75079,8.3791 -18.28294,16.20979 l -6.96706,7.2432 z"
          id="path108"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#cc0d33;fill-opacity:1;stroke-width:0.5"
          d="m 590.02907,136.4162 c 8.09917,-9.90182 10.68456,-14.35217 11.53695,-19.85911 0.71196,-4.59966 -0.19854,-7.15971 -3.84239,-10.80356 -4.46761,-4.4676 -6.48526,-5.02722 -20.95287,-5.81156 -5.26608,-0.28549 -10.11631,-0.56827 -10.7783,-0.6284 -0.95756,-0.087 0.87978,-1.69372 8.98725,-7.85932 18.86673,-14.34785 30.05601,-24.15803 34.90847,-30.60595 1.80351,-2.3965 2.18993,-3.32152 2.40199,-5.75 0.21552,-2.46801 0.0791,-3.14857 -0.92639,-4.62297 -1.54947,-2.27196 -4.97697,-4.85164 -7.30533,-5.49828 -1.18656,-0.32954 -12.67799,-0.51824 -31.66758,-0.52001 -16.39287,-0.002 -30.86896,-0.14859 -32.16909,-0.3268 -1.43838,-0.19715 -2.47971,-0.62586 -2.65974,-1.09499 -0.70793,-1.84484 12.20119,-11.08151 27.38404,-19.59368 4.5375,-2.54392 11.70796,-6.56301 15.93436,-8.93131 4.2264,-2.36831 8.79385,-5.29318 10.1499,-6.49973 2.4014,-2.13665 4.41574,-5.23241 4.41574,-6.78636 0,-0.6861 3.91939,-0.76992 36,-0.76992 h 36 v 69 69 h -39.54202 -39.54201 z"
          id="path110"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#cc0d33;fill-opacity:1;stroke-width:0.5"
          d="m 529.75858,97.89175 c -0.17187,-0.85938 -0.3125,-9.10808 -0.3125,-18.33045 V 62.79334 l 22.15453,0.30653 c 13.09487,0.18118 22.70473,0.51572 23.5,0.81808 4.58445,1.743 -2.76832,8.16262 -30.81799,26.90686 -7.1024,4.74619 -13.20552,8.62944 -13.5625,8.62944 -0.35697,0 -0.78966,-0.70313 -0.96154,-1.5625 z"
          id="path112"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#cc0d33;fill-opacity:1;stroke-width:0.5"
          d="M 529.76553,19.84572 C 529.59734,19.21791 529.45666,14.598 529.45291,9.57925 l -0.007,-9.125 h 12.75 c 7.90342,0 12.75,0.18435 12.75,0.48498 0,0.97945 -17.61407,15.32864 -23.56238,19.19494 -1.27563,0.82914 -1.32093,0.82107 -1.61817,-0.28845 z"
          id="path114"
          inkscape:connector-curvature="0"
        />
        <path
          style="fill:#cc0d33;fill-opacity:1;stroke-width:0.5"
          d="m 529.44608,131.79478 v -6.65946 l 5.375,-0.88103 c 16.97343,-2.78214 25.94274,-3.88028 33.89496,-4.14986 7.67189,-0.26008 8.60676,-0.20203 9.39197,0.58318 1.59478,1.59477 0.51738,3.50035 -6.67462,11.80523 l -5.16255,5.96141 h -18.41238 -18.41238 z"
          id="path116"
          inkscape:connector-curvature="0"
        />
      </svg>
      <div class="header-text">{{ title }}</div>
      <div class="right mobile-menu" v-on:click="toggleMenu">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="M 0.22233287,88.354191 V 80.912767 H 50.006562 99.790793 v 7.441424 11.441425 H 50.006562 0.22233287 Z m 0,-36.328774 V 40.583992 H 50.006562 99.790793 v 11.441425 7.441425 H 50.006562 0.22233287 Z m 0,-40.042739 V 0.25521746 H 50.006562 99.790793 V 11.982678 19.710139 H 50.006562 0.22233287 Z"
          />
        </svg>
      </div>
      <div class="right right-button" v-on:click="showBasemaps">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="m 1.9047991,75.001551 8.6949099,-5.41655 39.494588,18.206837 38.544793,-19.589982 10.159575,4.868088 c 0,0 -46.39736,24.681363 -48.417007,24.533329 z M 50.112199,75.488718 2.5727037,50.648977 12.236541,45.471711 50.373524,65.011795 89.67716,44.078769 98.448108,48.783841 Z M 2.1111081,27.901659 49.735615,2.0391867 98.219705,27.901659 50.057371,53.505948 Z"
          />
        </svg>
      </div>
      <div class="right-button" v-on:click="showSelection">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="M 0.24650688,99.695933 0.21458607,0.36012577 99.64842,0.34975285 99.691599,99.642393 0.24650688,99.695555 Z M 88.477115,11.245932 l -77.210347,0.151864 0.124288,76.921019 77.013265,0.18986 z M 32.68432,62.12551 22.632103,52.071478 l 2.498314,-2.498307 2.498297,-2.49831 7.610695,7.608289 7.610677,7.60829 16.497518,-16.496402 16.497521,-16.496403 2.495764,2.502871 2.495773,2.502874 L 61.89811,53.241963 C 51.481906,63.657634 42.909376,72.179545 42.848038,72.179545 c -0.06132,0 -4.634999,-4.524318 -10.163718,-10.054035 z"
          />
        </svg>
      </div>
      <div class="right-button" v-on:click="showLegend">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="M 0.49320281,85.358539 V 74.999727 h 9.80453019 9.804534 v 10.358812 10.35882 H 10.297733 0.49320281 Z M 31.5165,85.52836 V 79.918469 H 65.466507 99.41653 v 5.609891 5.609887 H 65.466507 31.5165 Z M 0.49320281,50.120607 V 39.761791 H 10.297733 20.102267 V 50.120607 60.479421 H 10.297733 0.49320281 Z M 31.5165,50.203645 v -5.60989 H 65.466507 99.41653 v 5.60989 5.609887 H 65.466507 31.5165 Z M 0.49320281,14.882674 V 4.5238562 H 10.297733 20.102267 V 14.882674 25.241485 H 10.297733 0.49320281 Z M 31.5165,14.796217 V 9.1863274 H 65.466507 99.41653 v 5.6098896 5.609891 H 65.466507 31.5165 Z"
          />
        </svg>
      </div>
      <div class="right-button" v-on:click="showAbout">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="M 1.1225478,99.15265 45.018252,19.53764 36.357974,4.1178071 43.266599,0.19699231 c 0,0 6.497105,11.22061969 6.709828,11.22061969 0.212724,0 6.186085,-11.07151381 6.186085,-11.07151381 L 63.245304,3.9164296 54.971135,19.574156 99.245503,99.033674 70.786726,99.088386 50.492846,68.886437 29.555279,99.162784 Z"
          />
        </svg>
      </div>
      <div class="right-button" v-on:click="showLinks">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="m 87.250915,87.090537 h -74.25989 l 0.338983,-74.488308 28.293785,0.02503 -0.0678,-12.19209123 H 0.4260523 V 99.621611 H 99.815888 V 58.293925 H 87.250915 Z M 54.120969,0.43516577 71.567298,17.915393 44.719841,44.712004 55.284812,55.243078 82.132271,28.446467 99.815888,46.028388 V 0.43516577 Z"
          />
        </svg>
      </div>
      <div class="right-button" v-on:click="showInfo">
        <svg class="btn-svg" viewBox="0 0 100 100">
          <path
            style="fill:#E7ECED;"
            d="m 50.029948,0.62230883 c -27.335903,0 -49.5751445,22.23924217 -49.5751445,49.57514417 0,27.335902 22.2388375,49.575144 49.5747405,49.575144 27.335902,0 49.575144,-22.239242 49.575144,-49.575144 0,-27.335902 -22.239242,-49.57514417 -49.57474,-49.57514417 z m 0,87.02596517 c -20.650551,0 -37.450821,-16.80027 -37.450821,-37.450821 0,-20.650551 16.80027,-37.450821 37.450821,-37.450821 20.650551,0 37.450821,16.80027 37.450821,37.450821 0,20.650551 -16.800674,37.450821 -37.450821,37.450821 z"
          />
          <rect
            style="fill:#E7ECED;"
            width="11.987895"
            x="43.899376"
            y="44.71072"
            height="31.568123"
          />
          <rect
            style="fill:#E7ECED;"
            width="11.987895"
            x="43.899376"
            y="23.931702"
            height="11.588298"
          />
        </svg>
      </div>
    </header>
    <main class="main">
      <web-map ref="webMap" />
      <div
        v-if="showPanel"
        class="rigth-panel"
        v-bind:style="{ height: panelHeight }"
      >
        <div class="side-header">
          <div class="side-header-text">{{ caption }}</div>
          <svg
            class="side-svg clickable right"
            viewBox="0 0 100 100"
            v-if="!unfoldPanel"
            v-on:click="collapsePanel"
          >
            <path
              style="fill:#E7ECED;"
              d="M 48.658644,99.215186 C 48.152111,98.965776 43.636214,94.368144 24.423093,74.540984 11.435934,61.138761 0.70805586,49.971156 0.58336506,49.72408 0.25845008,49.080261 0.27262638,47.641617 0.61033939,46.986403 0.7496822,46.716058 2.1768429,45.134847 3.7818052,43.472603 c 3.1834534,-3.297075 3.6231957,-3.63039 4.7857136,-3.627467 0.3531661,9.39e-4 0.8649634,0.11363 1.1828132,0.260561 0.439808,0.203305 4.823533,4.65275 20.387571,20.693212 L 49.965197,81.233126 69.85551,60.743727 c 19.089345,-19.6643 19.917324,-20.498369 20.561,-20.712176 0.778289,-0.258519 1.74636,-0.204312 2.396843,0.134209 0.230262,0.119833 1.727553,1.554183 3.327316,3.187449 3.250391,3.318464 3.502129,3.679809 3.49948,5.023187 -9.53e-4,0.493209 -0.09188,0.977777 -0.252843,1.347684 -0.367604,0.844803 -47.231291,49.155091 -48.051768,49.535044 -0.795583,0.368422 -1.875411,0.350697 -2.676894,-0.04394 z m 0,-39.403925 C 48.172707,59.556517 42.841642,54.126304 24.362319,35.063075 1.6182003,11.60029 0.68005441,10.61412 0.4727646,9.9506133 0.22572597,9.1598774 0.27694306,8.2877974 0.61499596,7.5288033 0.87663662,6.9413668 6.5088136,1.0806124 7.1356931,0.74346789 7.754373,0.410734 9.2648257,0.41445822 9.9370917,0.75038101 10.272312,0.91788294 16.906657,7.6617668 30.231667,21.380034 l 19.79655,20.3808 19.796551,-20.399628 C 85.351971,5.3609888 89.74215,0.9056599 90.181598,0.70228547 c 0.737431,-0.34127962 1.755786,-0.3404687 2.490132,0.001983 0.762908,0.35577033 6.240444,5.95592933 6.67087,6.82020393 0.380099,0.7632204 0.40905,1.9663648 0.06573,2.7317206 -0.28839,0.642906 -47.33257,49.155754 -48.041059,49.540846 -0.285688,0.155285 -0.782257,0.270926 -1.276803,0.297344 -0.673008,0.03595 -0.914128,-0.01173 -1.431827,-0.283117 z"
            />
          </svg>
          <svg
            class="side-svg clickable right"
            viewBox="0 0 100 100"
            v-if="unfoldPanel"
            v-on:click="collapsePanel"
          >
            <path
              style="fill:#E7ECED;"
              d="m 51.155582,0.75160019 c 0.507302,0.24784324 5.037387,4.83149581 24.311697,24.59917881 13.02852,13.362019 23.790863,24.496413 23.916317,24.743103 0.326903,0.642811 0.317173,2.081492 -0.01851,2.737747 -0.138507,0.270774 -1.560773,1.856389 -3.16059,3.523585 -3.173248,3.306899 -3.611958,3.641571 -4.77448,3.642241 -0.353167,1.53e-4 -0.86531,-0.110956 -1.183613,-0.256904 -0.440434,-0.201944 -4.83789,-4.637819 -20.451431,-20.6301 L 49.904613,18.737613 30.077723,39.288389 C 11.049246,59.011596 10.223849,59.84822 9.5808369,60.064015 8.8033507,60.324939 7.8351168,60.273724 7.1835906,59.937215 6.9529593,59.818094 5.4512423,58.388379 3.8464389,56.760065 0.58580691,53.451663 0.33295329,53.091098 0.33145024,51.747718 0.33087885,51.254508 0.42030775,50.769662 0.58012669,50.399259 0.94511787,49.553324 47.659266,1.0984231 48.478565,0.71593598 49.273006,0.3450568 50.352883,0.35944425 51.155582,0.75160219 Z M 51.27737,40.155337 c 0.486722,0.253241 5.834544,5.666951 24.372699,24.672974 22.816527,23.392377 23.757717,24.375643 23.967056,25.038505 0.249482,0.789969 0.20096,1.662203 -0.134745,2.422238 -0.259824,0.588243 -5.87386,6.466377 -6.499695,6.805457 -0.617648,0.334645 -2.128105,0.335589 -2.801406,0.0017 C 89.845542,98.929792 83.190385,92.206445 69.82304,78.529427 L 49.963592,58.209911 30.230186,78.670627 C 14.75251,94.718759 10.376122,99.187635 9.9373044,99.392367 9.2009318,99.735924 8.1825791,99.738261 7.4471782,99.39808 6.6831742,99.04467 1.1883558,93.461467 0.75526057,92.598527 0.37280446,91.836485 0.34013499,90.633436 0.68108784,89.867022 0.9674894,89.223228 47.861504,40.56521 48.568799,40.177931 c 0.285207,-0.156168 0.781416,-0.273343 1.275878,-0.301289 0.672894,-0.03803 0.91416,0.0089 1.432696,0.27869 z"
            />
          </svg>
          <svg
            class="side-svg clickable"
            viewBox="0 0 100 100"
            v-on:click="hidePanel"
          >
            <path
              style="fill:#E7ECED;"
              d="M 11.353296,99.60087 C 10.158652,99.2886 9.777993,98.969958 5.6977643,94.866972 2.1057207,91.254898 1.8304722,90.952618 1.4852896,90.24071 0.81477748,88.857864 0.81105034,87.29604 1.4749676,85.913833 1.8282131,85.178419 2.2844961,84.709318 19.173051,67.71852 L 36.508541,50.278081 18.925209,32.657969 C 9.2543694,22.966907 1.2302061,14.855055 1.0937227,14.631624 0.41213551,13.515821 0.15046462,11.993643 0.44367211,10.850191 0.78290636,9.5272428 0.88490944,9.402275 5.0075514,5.258931 7.1356118,3.1201823 9.0858095,1.2352303 9.3413268,1.0701527 10.765399,0.15011615 12.606359,0.04347386 14.201289,0.78862952 14.819598,1.0775028 15.962205,2.1990248 32.609529,18.857231 L 50.358546,36.617837 67.650099,19.29943 C 77.160452,9.7743007 85.147032,1.8489971 85.398046,1.6876364 c 1.55419,-0.9990684 3.787417,-0.98652366 5.286503,0.0297 0.260637,0.1766771 2.183978,2.0121569 4.274096,4.0788374 3.591793,3.5515215 3.820368,3.7993782 4.167595,4.5192852 0.694383,1.439636 0.72604,2.858533 0.09617,4.310142 -0.249317,0.574588 -1.426922,1.778419 -17.770837,18.166619 L 63.947739,50.343479 81.309931,67.677001 c 9.549196,9.533438 17.471827,17.516324 17.605839,17.739747 0.921169,1.535767 1.004823,3.303207 0.230734,4.874735 -0.318635,0.646893 -0.709061,1.068801 -4.336329,4.685967 -4.257301,4.245426 -4.384968,4.350041 -5.683009,4.656488 -1.163701,0.274734 -2.42262,0.119665 -3.466787,-0.427051 C 85.26288,98.998765 81.147235,94.938683 67.725487,81.514131 L 50.306479,64.091491 32.887759,81.514359 C 19.456606,94.948716 15.350941,98.999012 14.953153,99.207113 c -1.078967,0.564456 -2.395801,0.708488 -3.599857,0.393757 z"
            />
          </svg>
        </div>
        <div class="mobile-header">
          <svg
            class="btn-svg clickable"
            viewBox="0 0 100 100"
            v-on:click="showBasemaps"
          >
            <path
              style="fill:#E7ECED;"
              d="m 1.9047991,75.001551 8.6949099,-5.41655 39.494588,18.206837 38.544793,-19.589982 10.159575,4.868088 c 0,0 -46.39736,24.681363 -48.417007,24.533329 z M 50.112199,75.488718 2.5727037,50.648977 12.236541,45.471711 50.373524,65.011795 89.67716,44.078769 98.448108,48.783841 Z M 2.1111081,27.901659 49.735615,2.0391867 98.219705,27.901659 50.057371,53.505948 Z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button"
            viewBox="0 0 100 100"
            v-on:click="showSelection"
          >
            <path
              style="fill:#E7ECED;"
              d="M 0.24650688,99.695933 0.21458607,0.36012577 99.64842,0.34975285 99.691599,99.642393 0.24650688,99.695555 Z M 88.477115,11.245932 l -77.210347,0.151864 0.124288,76.921019 77.013265,0.18986 z M 32.68432,62.12551 22.632103,52.071478 l 2.498314,-2.498307 2.498297,-2.49831 7.610695,7.608289 7.610677,7.60829 16.497518,-16.496402 16.497521,-16.496403 2.495764,2.502871 2.495773,2.502874 L 61.89811,53.241963 C 51.481906,63.657634 42.909376,72.179545 42.848038,72.179545 c -0.06132,0 -4.634999,-4.524318 -10.163718,-10.054035 z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button"
            viewBox="0 0 100 100"
            v-on:click="showLegend"
          >
            <path
              style="fill:#E7ECED;"
              d="M 0.49320281,85.358539 V 74.999727 h 9.80453019 9.804534 v 10.358812 10.35882 H 10.297733 0.49320281 Z M 31.5165,85.52836 V 79.918469 H 65.466507 99.41653 v 5.609891 5.609887 H 65.466507 31.5165 Z M 0.49320281,50.120607 V 39.761791 H 10.297733 20.102267 V 50.120607 60.479421 H 10.297733 0.49320281 Z M 31.5165,50.203645 v -5.60989 H 65.466507 99.41653 v 5.60989 5.609887 H 65.466507 31.5165 Z M 0.49320281,14.882674 V 4.5238562 H 10.297733 20.102267 V 14.882674 25.241485 H 10.297733 0.49320281 Z M 31.5165,14.796217 V 9.1863274 H 65.466507 99.41653 v 5.6098896 5.609891 H 65.466507 31.5165 Z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button"
            viewBox="0 0 100 100"
            v-on:click="showAbout"
          >
            <path
              style="fill:#E7ECED;"
              d="M 1.1225478,99.15265 45.018252,19.53764 36.357974,4.1178071 43.266599,0.19699231 c 0,0 6.497105,11.22061969 6.709828,11.22061969 0.212724,0 6.186085,-11.07151381 6.186085,-11.07151381 L 63.245304,3.9164296 54.971135,19.574156 99.245503,99.033674 70.786726,99.088386 50.492846,68.886437 29.555279,99.162784 Z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button"
            viewBox="0 0 100 100"
            v-on:click="showLinks"
          >
            <path
              style="fill:#E7ECED;"
              d="m 87.250915,87.090537 h -74.25989 l 0.338983,-74.488308 28.293785,0.02503 -0.0678,-12.19209123 H 0.4260523 V 99.621611 H 99.815888 V 58.293925 H 87.250915 Z M 54.120969,0.43516577 71.567298,17.915393 44.719841,44.712004 55.284812,55.243078 82.132271,28.446467 99.815888,46.028388 V 0.43516577 Z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button"
            viewBox="0 0 100 100"
            v-on:click="showInfo"
          >
            <path
              style="fill:#E7ECED;"
              d="m 50.029948,0.62230883 c -27.335903,0 -49.5751445,22.23924217 -49.5751445,49.57514417 0,27.335902 22.2388375,49.575144 49.5747405,49.575144 27.335902,0 49.575144,-22.239242 49.575144,-49.575144 0,-27.335902 -22.239242,-49.57514417 -49.57474,-49.57514417 z m 0,87.02596517 c -20.650551,0 -37.450821,-16.80027 -37.450821,-37.450821 0,-20.650551 16.80027,-37.450821 37.450821,-37.450821 20.650551,0 37.450821,16.80027 37.450821,37.450821 0,20.650551 -16.800674,37.450821 -37.450821,37.450821 z"
            />
            <rect
              style="fill:#E7ECED;"
              width="11.987895"
              x="43.899376"
              y="44.71072"
              height="31.568123"
            />
            <rect
              style="fill:#E7ECED;"
              width="11.987895"
              x="43.899376"
              y="23.931702"
              height="11.588298"
            />
          </svg>
          <svg
            class="btn-svg mobile-button right"
            viewBox="0 0 100 100"
            v-if="!unfoldPanel"
            v-on:click="collapsePanel"
          >
            <path
              style="fill:#E7ECED;"
              d="M 48.658644,99.215186 C 48.152111,98.965776 43.636214,94.368144 24.423093,74.540984 11.435934,61.138761 0.70805586,49.971156 0.58336506,49.72408 0.25845008,49.080261 0.27262638,47.641617 0.61033939,46.986403 0.7496822,46.716058 2.1768429,45.134847 3.7818052,43.472603 c 3.1834534,-3.297075 3.6231957,-3.63039 4.7857136,-3.627467 0.3531661,9.39e-4 0.8649634,0.11363 1.1828132,0.260561 0.439808,0.203305 4.823533,4.65275 20.387571,20.693212 L 49.965197,81.233126 69.85551,60.743727 c 19.089345,-19.6643 19.917324,-20.498369 20.561,-20.712176 0.778289,-0.258519 1.74636,-0.204312 2.396843,0.134209 0.230262,0.119833 1.727553,1.554183 3.327316,3.187449 3.250391,3.318464 3.502129,3.679809 3.49948,5.023187 -9.53e-4,0.493209 -0.09188,0.977777 -0.252843,1.347684 -0.367604,0.844803 -47.231291,49.155091 -48.051768,49.535044 -0.795583,0.368422 -1.875411,0.350697 -2.676894,-0.04394 z m 0,-39.403925 C 48.172707,59.556517 42.841642,54.126304 24.362319,35.063075 1.6182003,11.60029 0.68005441,10.61412 0.4727646,9.9506133 0.22572597,9.1598774 0.27694306,8.2877974 0.61499596,7.5288033 0.87663662,6.9413668 6.5088136,1.0806124 7.1356931,0.74346789 7.754373,0.410734 9.2648257,0.41445822 9.9370917,0.75038101 10.272312,0.91788294 16.906657,7.6617668 30.231667,21.380034 l 19.79655,20.3808 19.796551,-20.399628 C 85.351971,5.3609888 89.74215,0.9056599 90.181598,0.70228547 c 0.737431,-0.34127962 1.755786,-0.3404687 2.490132,0.001983 0.762908,0.35577033 6.240444,5.95592933 6.67087,6.82020393 0.380099,0.7632204 0.40905,1.9663648 0.06573,2.7317206 -0.28839,0.642906 -47.33257,49.155754 -48.041059,49.540846 -0.285688,0.155285 -0.782257,0.270926 -1.276803,0.297344 -0.673008,0.03595 -0.914128,-0.01173 -1.431827,-0.283117 z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button right"
            viewBox="0 0 100 100"
            v-if="unfoldPanel"
            v-on:click="collapsePanel"
          >
            <path
              style="fill:#E7ECED;"
              d="m 51.155582,0.75160019 c 0.507302,0.24784324 5.037387,4.83149581 24.311697,24.59917881 13.02852,13.362019 23.790863,24.496413 23.916317,24.743103 0.326903,0.642811 0.317173,2.081492 -0.01851,2.737747 -0.138507,0.270774 -1.560773,1.856389 -3.16059,3.523585 -3.173248,3.306899 -3.611958,3.641571 -4.77448,3.642241 -0.353167,1.53e-4 -0.86531,-0.110956 -1.183613,-0.256904 -0.440434,-0.201944 -4.83789,-4.637819 -20.451431,-20.6301 L 49.904613,18.737613 30.077723,39.288389 C 11.049246,59.011596 10.223849,59.84822 9.5808369,60.064015 8.8033507,60.324939 7.8351168,60.273724 7.1835906,59.937215 6.9529593,59.818094 5.4512423,58.388379 3.8464389,56.760065 0.58580691,53.451663 0.33295329,53.091098 0.33145024,51.747718 0.33087885,51.254508 0.42030775,50.769662 0.58012669,50.399259 0.94511787,49.553324 47.659266,1.0984231 48.478565,0.71593598 49.273006,0.3450568 50.352883,0.35944425 51.155582,0.75160219 Z M 51.27737,40.155337 c 0.486722,0.253241 5.834544,5.666951 24.372699,24.672974 22.816527,23.392377 23.757717,24.375643 23.967056,25.038505 0.249482,0.789969 0.20096,1.662203 -0.134745,2.422238 -0.259824,0.588243 -5.87386,6.466377 -6.499695,6.805457 -0.617648,0.334645 -2.128105,0.335589 -2.801406,0.0017 C 89.845542,98.929792 83.190385,92.206445 69.82304,78.529427 L 49.963592,58.209911 30.230186,78.670627 C 14.75251,94.718759 10.376122,99.187635 9.9373044,99.392367 9.2009318,99.735924 8.1825791,99.738261 7.4471782,99.39808 6.6831742,99.04467 1.1883558,93.461467 0.75526057,92.598527 0.37280446,91.836485 0.34013499,90.633436 0.68108784,89.867022 0.9674894,89.223228 47.861504,40.56521 48.568799,40.177931 c 0.285207,-0.156168 0.781416,-0.273343 1.275878,-0.301289 0.672894,-0.03803 0.91416,0.0089 1.432696,0.27869 z"
            />
          </svg>
          <svg
            class="btn-svg mobile-button"
            viewBox="0 0 100 100"
            v-on:click="hidePanel"
          >
            <path
              style="fill:#E7ECED;"
              d="M 11.353296,99.60087 C 10.158652,99.2886 9.777993,98.969958 5.6977643,94.866972 2.1057207,91.254898 1.8304722,90.952618 1.4852896,90.24071 0.81477748,88.857864 0.81105034,87.29604 1.4749676,85.913833 1.8282131,85.178419 2.2844961,84.709318 19.173051,67.71852 L 36.508541,50.278081 18.925209,32.657969 C 9.2543694,22.966907 1.2302061,14.855055 1.0937227,14.631624 0.41213551,13.515821 0.15046462,11.993643 0.44367211,10.850191 0.78290636,9.5272428 0.88490944,9.402275 5.0075514,5.258931 7.1356118,3.1201823 9.0858095,1.2352303 9.3413268,1.0701527 10.765399,0.15011615 12.606359,0.04347386 14.201289,0.78862952 14.819598,1.0775028 15.962205,2.1990248 32.609529,18.857231 L 50.358546,36.617837 67.650099,19.29943 C 77.160452,9.7743007 85.147032,1.8489971 85.398046,1.6876364 c 1.55419,-0.9990684 3.787417,-0.98652366 5.286503,0.0297 0.260637,0.1766771 2.183978,2.0121569 4.274096,4.0788374 3.591793,3.5515215 3.820368,3.7993782 4.167595,4.5192852 0.694383,1.439636 0.72604,2.858533 0.09617,4.310142 -0.249317,0.574588 -1.426922,1.778419 -17.770837,18.166619 L 63.947739,50.343479 81.309931,67.677001 c 9.549196,9.533438 17.471827,17.516324 17.605839,17.739747 0.921169,1.535767 1.004823,3.303207 0.230734,4.874735 -0.318635,0.646893 -0.709061,1.068801 -4.336329,4.685967 -4.257301,4.245426 -4.384968,4.350041 -5.683009,4.656488 -1.163701,0.274734 -2.42262,0.119665 -3.466787,-0.427051 C 85.26288,98.998765 81.147235,94.938683 67.725487,81.514131 L 50.306479,64.091491 32.887759,81.514359 C 19.456606,94.948716 15.350941,98.999012 14.953153,99.207113 c -1.078967,0.564456 -2.395801,0.708488 -3.599857,0.393757 z"
            />
          </svg>
        </div>
        <v-app v-if="unfoldPanel" class="side">
          <component
            :is="component"
            :payload="payload"
            :showZotavovaci="showZotavovaci"
            :showJine="showJine"
            @toggleShowZotavovaci="toggleShowZotavovaci($event)"
            @toggleShowJine="toggleShowJine($event)"
            @caption="changeCaption"
          ></component>
          <!-- <router-view @caption="changeCaption" /> -->
        </v-app>
      </div>
    </main>
  </div>
</template>

<script>
import WebMap from "./components/WebMap.vue";
import Detail from "./views/Detail.vue";
import About from "./views/About.vue";
import Basemaps from "./views/Basemaps.vue";
import Legend from "./views/Legend.vue";
import Selection from "./views/Selection.vue";
import Info from "./views/Info.vue";
import Links from "./views/Links.vue";
import { bus } from "./main";

export default {
  name: "app",
  components: {
    WebMap,
    Detail,
    About,
    Basemaps,
    Legend,
    Selection,
    Info,
    Links
  },
  data() {
    return {
      title: "LETNÍ TÁBORY",
      caption: "",
      showPanel: false,
      unfoldPanel: false,
      panelHeight: "96.5%",
      seasonUrl:
        "https://fl-img-media.s3.amazonaws.com/uploads/2017/04/img-full-gc-@0.5x.png",
      longTermUrl:
        "https://fl-img-media.s3.amazonaws.com/uploads/2017/04/img-full-gc-@0.5x.png",
      ortofotoImg:
        "https://geoportal.mzcr.cz/portal/sharing/rest/content/items/a4642f2c2f954aa690b45a7eb5f32938/info/thumbnail/ago_downloaded.png",
      topoImg:
        "https://geoportal.mzcr.cz/portal/sharing/rest/content/items/96e9e20aa36e46139adcd1d8b540d25d/info/thumbnail/ago_downloaded.png",
      basicImg:
        "https://geoportal.mzcr.cz/portal/sharing/rest/content/items/f1b3330b4f3d47afadba8e95f7bb8da2/info/thumbnail/ago_downloaded.png",
      component: null,
      payload: null,
      showZotavovaci: true,
      showJine: true
    };
  },
  created() {
    bus.$on("detailChanged", (show, attributes, sessions) => {
      if (attributes != undefined) {
        this.component = "Detail";
        this.payload = attributes;
        this.payload.sessions = sessions;
        this.showDetail();
      } else {
        this.showPanel = false;
      }
    });
    // let path = this.$route.path;
    // if(path == "/info" || path == "/about" || path == "/legend" || path == "/selection" || path == "/basemaps" || path == "/links" || path.includes("detail")){
    //   this.showPanel = true;
    //   this.unfoldPanel = true;
    // }
  },
  methods: {
    changeCaption(caption) {
      // this.$router.history.current["path"] !== "/user/config";
      this.caption = caption;
    },
    toggleMenu() {
      // this.unfoldPanel = !this.unfoldPanel;
      this.showPanel = !this.showPanel;
    },
    showAbout() {
      this.component = "About";
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/about' }).catch(() => {});
    },
    showInfo() {
      this.component = "Info";
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/info' }).catch(() => {});
    },
    showBasemaps() {
      this.component = "Basemaps";
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/basemaps' }).catch(() => {});
    },
    showLegend() {
      this.component = "Legend";
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/legend' }).catch(() => {});
    },
    showDetail() {
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/detail/' + id }).catch((err) => {err});
    },
    showLinks() {
      this.component = "Links";
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/links' }).catch(() => {});
    },
    showSelection() {
      this.component = "Selection";
      this.showPanel = true;
      this.uncoverPanel();
      // this.$router.push({ path: '/selection' }).catch(() => {});
    },
    collapsePanel() {
      this.unfoldPanel = !this.unfoldPanel;
      this.unfoldPanel ? (this.panelHeight = "96%") : (this.panelHeight = null);
    },
    uncoverPanel() {
      this.unfoldPanel = true;
      this.panelHeight = "96%";
    },
    collapseMobilePanel() {
      this.unfoldPanel = !this.unfoldPanel;
      this.unfoldPanel
        ? (this.panelHeight = "96%")
        : (this.panelHeight = "42px");
    },
    hidePanel() {
      this.showPanel = false;
    },
    toggleShowZotavovaci(value) {
      this.showZotavovaci = value;

      this.$root.$refs.webMap.changeData(this.showZotavovaci, this.showJine);
    },
    toggleShowJine(value) {
      this.showJine = value;

      this.$root.$refs.webMap.changeData(this.showZotavovaci, this.showJine);
    }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

html {
  overflow-y: hidden;
}

h2 {
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

h3 {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.wrapper {
  margin: 0 auto;
  display: grid;
  grid-template-rows: 40px auto;
  height: 100vh;
}

.header {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  background-color: #006622;
  color: #e7eced;
}

.side {
  margin: 5px;
  padding: 2.5em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 0;
  padding-bottom: 0;
  height: 94%;
  overflow: auto;
  line-height: 1;
}

.side-header {
  grid-column: 1 / -1;
  display: flex;
  padding: 7px;
  align-items: center;
  background-color: #006622;
  color: #e7eced;
}

.mobile-header {
  grid-column: 1 / -1;
  display: none;
  padding: 5px;
  align-items: center;
  background-color: #006622;
  color: #e7eced;
}

.main {
  position: relative;
  height: 100%;
}

.header-text {
  text-transform: uppercase;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 19px;
  display: inline-block;
  margin-left: 10px;
  font-weight: bold;
}

.side-header-text {
  display: inline-block;
  font-family: Arial, Helvetica, sans-serif;
}

.logo {
  height: 30px;
  width: 145px;
  margin-left: 10px;
  margin-right: 10px;
}

.btn-svg {
  display: inline-block;
  height: 30px;
  padding: 0px 10px;
}

.side-svg {
  display: inline-block;
  height: 15px;
  padding: 0px 5px;
}

.rigth-panel {
  position: absolute;
  top: 10px;
  right: 0px;
  z-index: 1;
  padding: 0px;
  background-color: #e7eced;
  width: 350px;
  margin-right: 10px;
}

.clickable {
  cursor: pointer;
}

.right-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-left: 2px solid #323e4f;
}

.mobile-button {
  cursor: pointer;
  border-left: 2px solid #323e4f;
}

.mobile-menu {
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.right {
  margin-left: auto;
}

.v-messages {
  min-height: 0;
}

.v-slider__track-background,
.v-slider__track-fill {
  height: 3px !important;
}

.v-input__slot {
  margin-bottom: 0;
}

@media (max-width: 800px) {
  .mobile-menu {
    display: flex;
  }
  .right-button {
    display: none;
  }
  .mobile-header {
    display: flex;
  }
  .side-header {
    display: none;
  }
  .rigth-panel {
    position: absolute;
    top: 10px;
    left: 10px;
    width: auto;
    z-index: 1;
    padding: 0px;
    background-color: #ffffff;
  }
}
</style>
